import { KEY_FEATURES } from './const';
import useEventBus from '@/natives/libs/hooks/useEventBus';
const countryOrRegionChange = useEventBus('country-or-region-change');

function initData(index) {
  var data = KEY_FEATURES;
  if (!data) {
    return;
  }
  var flag = 0;
  if (index || index === 0) {
    flag = index;
  } else {
    flag = data.country;
  }
  var show = data.countriesList.includes(flag);
  var element = document.getElementById('4g');
  if (!show && element) {
    element.style.display = 'none';
  } else {
    element.style.display = 'inherit';
  }
}
countryOrRegionChange.on((index) => {
  initData(index);
});
/**
 * mounted
 */
(function () {
  initData();
})();
